import { apiUserAppClient, apiUserFormClient } from "../../api/apiSvtUser";

import { toast } from "react-toastify";
import i18n from "i18next";
const t = i18n.t.bind(i18n);

export const getEntitiesByEmail = async () => {
    try {
        const response = await apiUserAppClient.get(
            "/userassessment/legalentities"
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAllTemplateMaster = async (languageId) => {
    try {
        const response = await apiUserAppClient.get(`userassessment/templatemaster/${languageId}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAssessmentQuestions = async (
    assessmentId,
    levelId,
    languageId
) => {
    try {
        const response = await apiUserAppClient.get(
            "userassessment/assessment-questions?assessmentId=" +
                assessmentId +
                "&levelId=" +
                levelId +
                "&languageId=" +
                languageId
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getPrevAssessmentResponses = async (
    assessmentId,
    userId,
    organizationId,
    languageId
) => {
    try {
        const response = await apiUserAppClient.get(
            "userassessment/assessment-submissions?assessmentId=" +
                assessmentId +
                "&organizationId=" +
                organizationId +
                "&languageId=" +
                languageId
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const submitAssessment = async (data) => {
    try {
        const response = await apiUserFormClient.post("userassessment", data);
        !response?.data?.data?.isSubmitted &&
            toast.success(t("answersSavedSuccess"), {
                position: "top-center",
            });
        return response.data;
    } catch (error) {
        toast.error(t("answersSavedError"), {
            position: "top-center",
        });
        return null;
    }
};

export const retakeAssessment = async (
    assessmentId,
    userId,
    organizationId,
    languageId
) => {
    try {
        const response = await apiUserAppClient.put(
            "userassessment/deactivate?assessmentId=" +
                assessmentId +
                "&organizationId=" +
                organizationId +
                "&languageId=" +
                languageId
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const checkLanguageSubmission = async (
    templateMasterId,
    organizationId,
    languageId
) => {
    try {
        const response = await apiUserAppClient.get(
            "userassessment/check-submission/" + templateMasterId + "/" + organizationId + "/" + languageId);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getSasTokenForEvidence = async () => {
    try {
        const response = await apiUserAppClient.get(
            "userassessment/evidences/sas"
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getSasTokenForTile = async () => {
    try {
        const response = await apiUserAppClient.get(
            "userassessment/template-master-images/sas"
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const deleteEvidence = async (assessmentSubmissionId, questionId) => {
    try {
        const response = await apiUserAppClient.put(
            "/userassessment/" + assessmentSubmissionId + "/assessmentartifact",
            { questionId: questionId }
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};
